import { AuthorizeTransactionsList } from './authorizeTransactions-list.cmp';
import { Routes } from '@angular/router';

export const AuthorizeTransactionsRoutes: Routes = [
    { path: 'authorizeTransactions', data: { title: 'פעולות' }, component: AuthorizeTransactionsList}
];


//export const appRoutingProviders: any[] = [];
